/////////////-----------------Auth Action------------------///////////
export const SIGN_UP = "SIGN_UP";

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOG_OUT =  "LOG_OUT";

